(function () {
  function toggle(el, open) {
    if (!el) return;
    el.classList.toggle('is-open', open);
  }

  document.addEventListener('click', function (event) {
    var searchToggle = event.target.closest('[data-search-toggle]');
    if (searchToggle) {
      event.preventDefault();
      var band = document.querySelector('[data-search-band]');
      var isOpen = band && band.classList.contains('is-open');
      toggle(band, !isOpen);
      if (!isOpen && band) {
        var input = band.querySelector('input[name="q"]');
        if (input) input.focus();
      }
      return;
    }

    if (event.target.closest('[data-search-close]')) {
      event.preventDefault();
      toggle(document.querySelector('[data-search-band]'), false);
      return;
    }

    if (event.target.closest('[data-drawer-open]')) {
      event.preventDefault();
      toggle(document.querySelector('[data-drawer]'), true);
      return;
    }

    if (event.target.closest('[data-drawer-close]')) {
      event.preventDefault();
      toggle(document.querySelector('[data-drawer]'), false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      toggle(document.querySelector('[data-search-band]'), false);
      toggle(document.querySelector('[data-drawer]'), false);
    }
  });

  // Quantity steppers
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty]');
    if (!button) return;
    var wrap = button.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    value = button.getAttribute('data-qty') === 'up' ? value + 1 : Math.max(1, value - 1);
    input.value = value;
    if (input.form && input.hasAttribute('data-cart-quantity')) input.form.submit();
  });

  // Variant selection
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var variants = JSON.parse(picker.querySelector('[data-variant-json]').textContent);
    var selects = picker.querySelectorAll('select[data-option-index]');
    var idInput = picker.querySelector('[data-variant-id]');
    var priceEl = picker.querySelector('[data-variant-price]');
    var submit = picker.querySelector('[data-add-button]');

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.filter(function (v) {
        return chosen.every(function (value, index) { return v.options[index] === value; });
      })[0];
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html;
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? submit.dataset.addLabel : submit.dataset.soldLabel;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    selects.forEach(function (select) { select.addEventListener('change', update); });
  });
})();
